import { useSelector } from 'react-redux';
import { AuthState } from '../redux/auth';

export const useAuth = (): AuthState | undefined => {
    const auth = useSelector((state: any) => state.auth);
    return auth.id ? auth : undefined;
}
